var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11652_13720)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.333496,
    y: 14,
    width: 1,
    height: 16,
    rx: 0.5,
    transform: "rotate(-90 0.333496 14)",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.02356 11C5.8475 11 4.9253 9.99016 5.03178 8.81893L5.66814 1.81893C5.76179 0.788773 6.62552 2.13697e-08 7.65993 3.37048e-08L9.00707 4.97693e-08C10.0415 6.21045e-08 10.9052 0.788771 10.9989 1.81893L11.6352 8.81893C11.7417 9.99016 10.8195 11 9.64343 11L7.02356 11Z",
    fill: "#007AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11652_13720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white",
    transform: "translate(0.333496 14) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignBottom);
export default __webpack_public_path__ + "static/media/alignBottom.e551c6e4adc3d56158c9da87783e9512.svg";
export { ForwardRef as ReactComponent };